import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from '../../config/theme';
import { TextField, Typography, IconButton, InputAdornment, Container } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  page: {
    width: '100%',
    backgroundColor: '#EFEFEF',
    borderRadius: '16px',
    padding: '24px 14px 22px',
    boxSizing: 'border-box',
  },
  wrapper: {
    width: '100%',
  },
  title: {
    fontWeight: 700,
    color: "#2D6E2F",
    textAlign: 'center',
    marginBottom: '14px',
  },
  form: {
    width: '100%',
    borderRadius: '14px',
    backgroundColor: '#337D36',
    border: '1px solid #2A682C',
    padding: '18px 16px 16px',
    color: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
    textAlign: 'left',
    boxSizing: 'border-box',
  },
  warnForm: {
    marginBottom: '2px',
    fontSize: '0.95rem',
    color: '#FFD7D7',
    lineHeight: 1.4,
  },
  fieldLabel: {
    color: '#FFFFFF',
    fontSize: '1rem',
    marginBottom: '-4px',
  },
  field: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      '& fieldset': {
        borderColor: '#D4D8E2',
      },
      '&:hover fieldset': {
        borderColor: '#BCD8BD',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1D3D1E',
      },
    },
    '& .MuiInputBase-input': {
      color: '#1A1A1A',
      fontWeight: 600,
    },
  },
  helperText: {
    color: '#FFFFFF',
    marginTop: '4px',
    minHeight: '20px',
  },
  removeButton: {
    marginTop: '6px',
    borderRadius: '8px',
    backgroundColor: '#225424',
    color: '#FFFFFF',
    fontWeight: 700,
    textTransform: 'none',
    minHeight: '52px',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#1C441D',
    },
    '&:disabled': {
      opacity: 0.7,
      cursor: 'not-allowed',
    },
  },
  backLink: {
    display: 'block',
    marginTop: '4px',
    color: '#FFFFFF',
    opacity: 0.95,
    textDecoration: 'underline',
    fontSize: '0.95rem',
    textAlign: 'center',
    width: '100%',
  },
}));

export default function AccountRemove(props) {
  const classes = useStyles();

  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  function accountRemove(e) {
    e.preventDefault();
    setLoading(true);
    document.activeElement.blur();

    const formData = new FormData();
    formData.append("customer[password]", newPassword);

    axios
      .put(`/api/v1/customers/account_remove`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setErrors({});
        toast.success(res.data.message);
        setTimeout(() => {
          setLoading(false);
          window.location.href = "/";
        }, 5000);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response?.status === 422) {
          setErrors(error.response.data);
        } else {
          toast.error(`Erro ao processar solicitação.`);
        }
      })
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function checkPasswords() {
    return newPassword === "";
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.paper}>
        <div className={classes.page}>
          <Container maxWidth="sm" className={classes.wrapper}>
            <Typography variant="h5" className={classes.title}>
              Remover conta
            </Typography>
            <form className={classes.form} onSubmit={accountRemove}>
              <Typography className={classes.warnForm}>
                ATENCAO: apos confirmar a remocao da conta, seus dados nao poderao mais ser acessados
                e o valor disponivel para saque sera perdido.
              </Typography>

              <div className={classes.fieldLabel}>Senha atual:</div>
              <TextField
                name="new-password"
                className={classes.field}
                variant="outlined"
                required
                fullWidth
                value={newPassword}
                error={!!errors.password}
                type={showPassword ? 'text' : 'password'}
                helperText={errors.password || ""}
                FormHelperTextProps={{ className: classes.helperText }}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton tabIndex={-1} onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <button
                type="submit"
                className={classes.removeButton}
                disabled={checkPasswords() || loading}
              >
                {loading ? "Removendo..." : "Remover conta"}
              </button>

              <Link className={classes.backLink} to="/site/change_profile">
                Voltar para editar perfil
              </Link>
            </form>
          </Container>
        </div>
      </div>
    </ThemeProvider>
  );
}